class a {
  constructor(t, e) {
    this.value = t, this.expiryDate = e;
  }
}
const c = "_", l = 30 * 24 * 60 * 60;
class h {
  setItem(t, e, r = l) {
    const o = this.createExpiryDate(r).toJSON(), n = new a(e, o), i = JSON.stringify(n);
    localStorage.setItem(t, i);
  }
  getItem(t) {
    this.assertNotEmpty(t, "key");
    const e = this.getCacheEntry(t);
    if (e !== void 0) {
      if (e.expiryDate !== void 0 && this.isInThePast(new Date(e.expiryDate))) {
        this.removeItem(t);
        return;
      }
      return e.value;
    }
  }
  removeItem(t) {
    localStorage.removeItem(t);
  }
  removeAllItems() {
    localStorage.clear();
  }
  removeAllItemsWithKeyContainingString(t) {
    for (let e = localStorage.length - 1; e >= 0; e--) {
      const r = localStorage.key(e);
      r && r.indexOf(t) !== -1 && this.removeItem(r);
    }
  }
  removeExpiredItems() {
    const t = this.findExpiredKeys();
    this.removeItems(t);
  }
  getSize() {
    return localStorage.length;
  }
  createKey(t, e, ...r) {
    return this.assertNotEmpty(t, "domain"), this.assertNotEmpty(e, "moduleName"), [
      t,
      e,
      ...r.filter((n) => n !== void 0)
    ].map((n) => n.toLowerCase()).join(c);
  }
  getCacheEntry(t) {
    const e = localStorage.getItem(t);
    if (e !== null)
      try {
        return JSON.parse(e);
      } catch {
        return;
      }
  }
  removeItems(t) {
    for (const e of t)
      this.removeItem(e);
  }
  findExpiredKeys() {
    const t = [];
    for (let e = 0; e < localStorage.length; ++e) {
      const r = localStorage.key(e);
      if (r === null)
        continue;
      const o = this.getCacheEntry(r);
      o !== void 0 && this.isInThePast(new Date(o.expiryDate)) && t.push(r);
    }
    return t;
  }
  assertNotEmpty(t, e) {
    if (t.length === 0)
      throw new Error(`The ${e} must not be empty.`);
  }
  createExpiryDate(t) {
    const e = new Date();
    return e.setSeconds(e.getSeconds() + t), e;
  }
  isInThePast(t) {
    return new Date() > t;
  }
}
var y = /* @__PURE__ */ ((s) => (s.Foundation = "foundation", s))(y || {});
const m = new h();
function E() {
  return m;
}
export {
  y as KnownDomain,
  E as getCache
};
//# sourceMappingURL=index.js.map
